import React, { useState } from 'react';

interface ArticleImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  placeholderClassName?: string;
  containerClassName?: string;
}

const ArticleImage: React.FC<ArticleImageProps> = ({
  src,
  alt,
  className = '',
  placeholderClassName = '',
  containerClassName = '',
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const placeholderSrc = `${process.env.PUBLIC_URL}/images/article-placeholder.svg`;
  const shouldShowPlaceholder = !src || imageError;

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (shouldShowPlaceholder) {
    return (
      <div
        data-testid="article-image-container"
        className={`bg-black flex items-center justify-center ${containerClassName}`}
      >
        <img
          src={placeholderSrc}
          alt={`${alt} (画像なし)`}
          className={`w-full h-full object-cover ${className} ${placeholderClassName}`}
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div
      data-testid="article-image-container"
      className={`relative bg-black ${containerClassName}`}
    >
      {!imageLoaded && (
        <div className="absolute inset-0 bg-gray-800 animate-pulse flex items-center justify-center">
          <div className="text-white text-sm opacity-70">読み込み中...</div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${className} ${imageLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        onError={handleImageError}
        onLoad={handleImageLoad}
        loading="lazy"
      />
    </div>
  );
};

export default ArticleImage;
